/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_Spacex_Fine_Print_TokenizedInputs */

const en_campaigns_mag7_spacex_fine_print_tokenized = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_TokenizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The underlying stocks are tokenized by Coinbase, backed 1:1 by equity shares with full shareholder rights.`)
};

const de_campaigns_mag7_spacex_fine_print_tokenized = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_TokenizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die zugrunde liegenden Aktien werden von Coinbase tokenisiert und sind 1:1 durch Aktienanteile mit vollen Aktionärsrechten gedeckt.`)
};

const pt_br2_campaigns_mag7_spacex_fine_print_tokenized = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_TokenizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As ações subjacentes são tokenizadas pela Coinbase e lastreadas 1:1 em ações reais, com todos os direitos de acionista.`)
};

const tr_campaigns_mag7_spacex_fine_print_tokenized = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_TokenizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dayanak hisseler Coinbase tarafından tokenleştirilir ve tam hissedar haklarına sahip hisse senetleriyle 1:1 oranında teminatlandırılır.`)
};

const zh_cn2_campaigns_mag7_spacex_fine_print_tokenized = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_TokenizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`底层股票由 Coinbase 代币化，以 1:1 的实际股权作为支撑，并享有完整的股东权利。`)
};

const zh_hk2_campaigns_mag7_spacex_fine_print_tokenized = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_TokenizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相關股票由 Coinbase 代幣化，以 1:1 實際股份作支持，並享有完整股東權利。`)
};

const ko_kr2_campaigns_mag7_spacex_fine_print_tokenized = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_TokenizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기초 주식은 Coinbase가 토큰화하며, 완전한 주주 권리가 있는 실제 주식으로 1:1 뒷받침됩니다.`)
};

const ru_ru2_campaigns_mag7_spacex_fine_print_tokenized = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_TokenizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Базовые акции токенизированы Coinbase и обеспечены реальными акциями 1:1 с полными правами акционера.`)
};

const es_419_campaigns_mag7_spacex_fine_print_tokenized = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_TokenizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las acciones subyacentes están tokenizadas por Coinbase, respaldadas 1:1 por acciones reales con todos los derechos de accionista.`)
};

/**
* | output |
* | --- |
* | "The underlying stocks are tokenized by Coinbase, backed 1:1 by equity shares with full shareholder rights." |
*
* @param {Campaigns_Mag7_Spacex_Fine_Print_TokenizedInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_spacex_fine_print_tokenized = /** @type {((inputs?: Campaigns_Mag7_Spacex_Fine_Print_TokenizedInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Spacex_Fine_Print_TokenizedInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_spacex_fine_print_tokenized(inputs)
	if (locale === "de") return de_campaigns_mag7_spacex_fine_print_tokenized(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_spacex_fine_print_tokenized(inputs)
	if (locale === "tr") return tr_campaigns_mag7_spacex_fine_print_tokenized(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_spacex_fine_print_tokenized(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_spacex_fine_print_tokenized(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_spacex_fine_print_tokenized(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_spacex_fine_print_tokenized(inputs)
	return es_419_campaigns_mag7_spacex_fine_print_tokenized(inputs)
});